import {getAllVectorizationImages} from "../../api/vectorization";
import {IVectorizationDataModel, IVectorizedImageBatchModel} from "../../types/vectorization";
import {Storage} from "aws-amplify";
import {VECTORIZATION_S3_CONFIG} from "../../utils/storageUtil";
import {vectorizedBatchImageBuilder} from "../../utils/modelBuilder";
import {ToastError} from "../../utils/toastUtil";
import {v4 as uuidv4} from 'uuid';
import {formatDateToUTC} from "../../utils/dateUtils";

export const fetchVectorizationBatches = async (noItems: number, createdBy: string, isSeeAll: boolean) => {
    try {
        const vectorizationImages = await getAllVectorizationImages(noItems, createdBy, isSeeAll);
        return vectorizationImages.reduce((acc, item) => {
            const batchId = item.batch_id ?? uuidv4();
            if (!acc[batchId]) {
                acc[batchId] = [];
            }
            acc[batchId].push({...item, batch_id: batchId});

            return acc;
        }, {} as Record<string, IVectorizationDataModel[]>);

    } catch (error) {
        console.error(`fetchVectorizationBatches ${error}`);
        ToastError(String(error))
        return null;
    }
};

export const createVectorizationBatch = async (images: IVectorizationDataModel[]): Promise<IVectorizedImageBatchModel> => {
    const response: IVectorizedImageBatchModel[] = [];
    for (const image of images) {
        const existingBatch = response.find(item => item.batchId === image.batch_id);
        if (existingBatch) {
            existingBatch.batchImages.push(await vectorizedBatchImageBuilder(image));
        } else {
            try {
                const imageUrl = await Storage.get(image.input_file_key, {...VECTORIZATION_S3_CONFIG});
                response.push({
                    inputKey: image.input_file_key,
                    startedBy: image.created_by,
                    startedAt: formatDateToUTC(image.created_at),
                    batchId: image.batch_id,
                    url: imageUrl,
                    inputFilename: image.file_name,
                    batchImages: [await vectorizedBatchImageBuilder(image)]
                });
            } catch (error) {
                console.error(`createVectorizationBatch ${error}`);
                ToastError(String(error))
            }
        }
    }

    return response[0];
};
